import 'antd/dist/antd.css';
import moment from 'moment';
import { DatePicker } from 'antd';
import { useState, useEffect } from 'react';

const YearSelector = (props) => {

    const [selectedYear, setSelectedYear] = useState([]);

    let available_dict = {};
    if(props.streamReady){
        if(props.view === 1){
                available_dict = {'0': props.availableYear.uniqueDateMonthProvince,
                '1': props.availableYear.uniqueDateMonthWhole,
                '2': props.availableYear.uniqueDateWeekProvince,
                '3': props.availableYear.uniqueDateWeekWhole,
                '4': props.availableYear.uniqueDateYearProvince,
                '5': props.availableYear.uniqueDateYearWhole
            };
        } else if(props.view === 3){
            available_dict = {'0': props.availableYear.uniqueDateMonthGenderAge,
            };
        }  else if(props.view === 4){
            available_dict = {'0': props.availableYear.uniqueDateMonth,
            '1': props.availableYear.uniqueDateWeek,
            };
        } else if(props.view === 5){
            available_dict = {'0': props.availableYear.uniqueDateMonthSingle,
            '1': props.availableYear.uniqueDateMonthAll,
            };
        }
    } else {
        if(props.view === 1){
            available_dict = {'0': props.availableYear.uniqueDateMonthProvince,
            '1': props.availableYear.uniqueDateMonthWhole};
        } else if(props.view === 3){
            available_dict = {'0': props.availableYear.uniqueDateMonthGenderAge};
        } else if(props.view === 4){
            available_dict = {'0': props.availableYear.uniqueDateMonth};
        }
    }

    
    useEffect(() => {
        if(props.view === 1){
            setSelectedYear(props.availableYear.uniqueDateMonthProvince[0]);
        } else if(props.view === 3){
            setSelectedYear(props.availableYear.uniqueDateMonthGenderAge[0]);
        } else if(props.view === 4){
            setSelectedYear(props.availableYear.uniqueDateMonth[0]);
        } else if(props.view === 5){
            setSelectedYear(props.availableYear.uniqueDateMonthSingle[0]);
        }
    }, []);

    const getUnionYear = () => {
        let i = 0;
        let year_union = [];
        if(props.streamReady){
            if(props.view === 1){
                for(i=0; i < 6; i++){
                    year_union = [...new Set([...year_union, ...available_dict[i]])];
                }
            } else if(props.view === 3){
                for(i=0; i < 1; i++){
                    year_union = [...new Set([...year_union, ...available_dict[i]])];
                }
            } else if(props.view === 4){
                for(i=0; i < 2; i++){
                    year_union = [...new Set([...year_union, ...available_dict[i]])];
                }
            } else if(props.view === 5){
                for(i=0; i < 2; i++){
                    year_union = [...new Set([...year_union, ...available_dict[i]])];
                }
            }
        } else {
            if(props.view === 1){
                for(i=0; i < 2; i++){
                    year_union = [...new Set([...year_union, ...available_dict[i]])];
                }
            } else if(props.view === 3){
                year_union = [...new Set([...year_union, ...available_dict[0]])];
            } else if(props.view === 4){
                year_union = [...new Set([...year_union, ...available_dict[0]])];
            }
        }


        year_union.sort(function(a, b) {
        return a - b;
        });
        return year_union;
    }

    const all_available_year = getUnionYear(props.availableYear);

    function disabledDate(current) {
        const yearStart = moment().year(all_available_year[0]);
        const yearEnd = moment().year(all_available_year[all_available_year.length - 1]);
        return !(yearStart.isSameOrBefore(current) && yearEnd.isAfter(current));
    }

    function onChange(date, dateString) {
        if (date === null){
            setSelectedYear(selectedYear);
        } else {
            setSelectedYear(date.year());
        }
    }

    props.onChange(selectedYear);

    const customFormat = value => `${value.year()}`+ ' ถึง '+ `${value.year()+1}`;

    return (   
        <div>
            <DatePicker allowClear={false} onChange={onChange} 
            defaultValue={moment().year(all_available_year[0])} 
            disabledDate={disabledDate} picker="year" 
            format={customFormat} 
            defaultPickerValue={moment().year(all_available_year[0])}/>
        </div> 
      );
}
 
export default YearSelector;